import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import PostgrestQueryBuilder from './lib/PostgrestQueryBuilder';
import PostgrestRpcBuilder from './lib/PostgrestRpcBuilder';
import { DEFAULT_HEADERS } from './lib/constants';

var PostgrestClient = /*#__PURE__*/function () {
  /**
   * Creates a PostgREST client.
   *
   * @param url  URL of the PostgREST endpoint.
   * @param headers  Custom headers.
   * @param schema  Postgres schema to switch to.
   */
  function PostgrestClient(url) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? {} : _ref$headers,
        schema = _ref.schema,
        fetch = _ref.fetch,
        throwOnError = _ref.throwOnError;

    _classCallCheck(this, PostgrestClient);

    this.url = url;
    this.headers = Object.assign(Object.assign({}, DEFAULT_HEADERS), headers);
    this.schema = schema;
    this.fetch = fetch;
    this.shouldThrowOnError = throwOnError;
  }
  /**
   * Authenticates the request with JWT.
   *
   * @param token  The JWT token to use.
   */


  _createClass(PostgrestClient, [{
    key: "auth",
    value: function auth(token) {
      this.headers['Authorization'] = "Bearer ".concat(token);
      return this;
    }
    /**
     * Perform a table operation.
     *
     * @param table  The table name to operate on.
     */

  }, {
    key: "from",
    value: function from(table) {
      var url = "".concat(this.url, "/").concat(table);
      return new PostgrestQueryBuilder(url, {
        headers: this.headers,
        schema: this.schema,
        fetch: this.fetch,
        shouldThrowOnError: this.shouldThrowOnError
      });
    }
    /**
     * Perform a function call.
     *
     * @param fn  The function name to call.
     * @param params  The parameters to pass to the function call.
     * @param head  When set to true, no data will be returned.
     * @param count  Count algorithm to use to count rows in a table.
     */

  }, {
    key: "rpc",
    value: function rpc(fn, params) {
      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref2$head = _ref2.head,
          head = _ref2$head === void 0 ? false : _ref2$head,
          _ref2$count = _ref2.count,
          count = _ref2$count === void 0 ? null : _ref2$count;

      var url = "".concat(this.url, "/rpc/").concat(fn);
      return new PostgrestRpcBuilder(url, {
        headers: this.headers,
        schema: this.schema,
        fetch: this.fetch,
        shouldThrowOnError: this.shouldThrowOnError
      }).rpc(params, {
        head: head,
        count: count
      });
    }
  }]);

  return PostgrestClient;
}();

export { PostgrestClient as default };